function initCustomBundle() {
    const customBundleContainer = document.querySelector('.js-custom-bundle-container'); 
    const bundleBuilderModal = document.querySelector('.js-bundle-builder-modal');
    // watch for scrolled out of view then add the scrolled class to the custom bundle container
    if (customBundleContainer && bundleBuilderModal) {
        window.addEventListener('scroll', () => {
            if (window.scrollY > customBundleContainer.offsetTop + 500) {
                bundleBuilderModal.classList.add('scrolled');
            } else {
                bundleBuilderModal.classList.remove('scrolled');
            }
        });
    }

    const changeDealOptionButtons = document.querySelectorAll('.js-change-deal-option');
    changeDealOptionButtons.forEach(button => {
        button.addEventListener('click', () => {
            const dealOption = button.dataset.dealOption;
            changeDealOption(dealOption);
        });
    });

    const addToBundleButtons = document.querySelectorAll('.js-add-to-bundle');
    addToBundleButtons.forEach(button => {
        button.addEventListener('click', () => {
            const productId = button.dataset.productId;
            addToBundle(productId);
        });
    });

    updateButtonsState('not-ready');

    let removeButtons = document.querySelectorAll('.js-bundle-product-remove');
    removeButtons.forEach(button => {
        button.addEventListener('click', () => {
            removeFromBundle(button.dataset.variantId);
        });
    });

    let addBundleToCartButtons = document.querySelectorAll('.js-add-bundle-to-cart');
    addBundleToCartButtons.forEach(button => {
        button.addEventListener('click', () => {
            addBundleToCart();
        });
    });

    let optionValues = document.querySelectorAll('.js-bundle-product-card-option-value');
    optionValues.forEach(optionValue => {
        optionValue.addEventListener('click', () => {
            updateSelectedProductVariant(optionValue);
        });
    });

    let productCards = document.querySelectorAll('.js-custom-bundle-product-grid-item');
    productCards.forEach(productCard => {
        let selectedOptionValue = productCard.querySelector('.js-bundle-product-card-option-value.selected');
        if(selectedOptionValue) {
            updateSelectedProductVariant(selectedOptionValue);
        }
        ensureNonSaleVariantSelection(productCard);
        syncOptionLabelsFromSelectedOptions(productCard);
    });
}

function syncOptionLabelsFromSelectedOptions(productCard) {
    let optionGroups = productCard.querySelectorAll('.js-bundle-product-card-option');

    optionGroups.forEach(optionGroup => {
        let selectedOption = optionGroup.querySelector('.js-bundle-product-card-option-value.selected');
        let optionLabel = optionGroup.querySelector('.js-option-value');
        if (selectedOption && optionLabel) {
            optionLabel.innerHTML = selectedOption.dataset.optionItem;
        }
    });
}

function ensureNonSaleVariantSelection(productCard) {
    let selectedVariant = productCard.querySelector('.js-bundle-product-variant.selected');
    if (selectedVariant) return;

    let fallbackVariant = productCard.querySelector('.js-bundle-product-variant');
    if (!fallbackVariant) return;

    let variantTitle = fallbackVariant.dataset.title || '';
    let variantOptionText = variantTitle.includes(' - ') ? variantTitle.split(' - ')[1] : '';
    if (!variantOptionText) return;

    let optionValues = variantOptionText.split(' / ');
    let optionGroups = productCard.querySelectorAll('.js-bundle-product-card-option');
    let lastMatchedOption = null;

    optionGroups.forEach((optionGroup, index) => {
        let targetValue = optionValues[index];
        if (!targetValue) return;

        let optionItems = optionGroup.querySelectorAll('.js-bundle-product-card-option-value');
        let matchedOption = null;

        optionItems.forEach(item => {
            if (item.dataset.optionItem === targetValue) {
                matchedOption = item;
            }
        });

        if (!matchedOption) return;

        optionItems.forEach(item => item.classList.remove('selected'));
        matchedOption.classList.add('selected');

        let optionLabel = optionGroup.querySelector('.js-option-value');
        if (optionLabel) {
            optionLabel.innerHTML = targetValue;
        }

        lastMatchedOption = matchedOption;
    });

    if (lastMatchedOption) {
        updateSelectedProductVariant(lastMatchedOption);
    }
}

function addToBundle(productId) {
    let productCard = document.querySelector(`.js-custom-bundle-product-grid-item[data-product-id="${productId}"]`);
    let productCardVariant = productCard.querySelector('.js-bundle-product-variant.selected');

    let productVariantId = productCardVariant.value;
    let productImage = productCardVariant.dataset.image;
    let productTitle = productCardVariant.dataset.title;
    let productPrice = productCardVariant.dataset.price;
    let productAvailable = productCardVariant.dataset.available;
    let productImageAltText = productCardVariant.dataset.imageAltText;

    let bundleBuilder = document.querySelector('.js-bundle-builder');
    let bundleBuilderModal = document.querySelector('.js-bundle-builder-modal');

    let bundleBuilderProducts = bundleBuilder.querySelectorAll('.js-bundle-product');
    let bundleBuilderModalProducts = bundleBuilderModal.querySelectorAll('.js-bundle-product');

    let bundleBuilderProductIndex = 0;
    let emptySlotFound = false;

    bundleBuilderProducts.forEach((product, index) => {
        if (product.classList.contains('empty') && !emptySlotFound) {
            product.dataset.productId = productId;
            bundleBuilderProductIndex = index;
            product.querySelector('.js-bundle-product-image').src = productImage;
            product.querySelector('.js-bundle-product-image').srcset = productImage;
            product.querySelector('.js-bundle-product-image').alt = productImageAltText;
            product.querySelector('.js-bundle-product-title').innerHTML = productTitle;
            product.querySelector('.js-bundle-product-remove').dataset.variantId = productVariantId;
            product.dataset.price = productPrice;
            product.dataset.variantId = productVariantId;
            product.classList.remove('empty');
            emptySlotFound = true;
        }
    });

    bundleBuilderModalProducts[bundleBuilderProductIndex].dataset.productId = productId;
    bundleBuilderModalProducts[bundleBuilderProductIndex].querySelector('.js-bundle-product-image').src = productImage;
    bundleBuilderModalProducts[bundleBuilderProductIndex].querySelector('.js-bundle-product-image').srcset = productImage;
    bundleBuilderModalProducts[bundleBuilderProductIndex].querySelector('.js-bundle-product-remove').dataset.variantId = productVariantId;
    bundleBuilderModalProducts[bundleBuilderProductIndex].dataset.price = productPrice;
    bundleBuilderModalProducts[bundleBuilderProductIndex].dataset.variantId = productVariantId;
    bundleBuilderModalProducts[bundleBuilderProductIndex].classList.remove('empty');


    updateBundlePrice(bundleBuilderProducts);

    // check if the bundle is full
    let activeBundleItems = [];

    bundleBuilderProducts.forEach(product => {
        if(!product.classList.contains('empty')) {
            activeBundleItems.push(product);
        }
    });

    let bundleContainer = document.querySelector('.js-custom-bundle-container');
    let bundleItemsTotal = bundleContainer.dataset.dealOption === '1' ? 3 : 4;
    console.log('bundleBuilderProducts', activeBundleItems);
    console.log('bundleItemsTotal', activeBundleItems.length, bundleItemsTotal);
    if(activeBundleItems.length === bundleItemsTotal) {
        updateButtonsState('ready');
    } else {
        updateButtonsState('not-ready');
    }
}

function updateBundlePrice(products) {
    let totalPriceEls = document.querySelectorAll('.js-bundle-price');
    let totalSavingsEls = document.querySelectorAll('.js-bundle-saved');

    let dealOption = document.querySelector('.js-custom-bundle-container').dataset.dealOption;
    let discount = dealOption === '1' ? deal_1_discount : deal_2_discount;

    let totalPrice = 0;

    products.forEach(product => {
        totalPrice += parseFloat(product.dataset.price);
    });


    let totalSavings = (totalPrice * discount).toFixed(2);
    totalPrice = (totalPrice - totalSavings).toFixed(2);


    totalPriceEls.forEach(el => {
        el.innerHTML = totalPrice;
    });

    totalSavingsEls.forEach(el => {
        el.innerHTML = totalSavings;
    });
}
    
function updateButtonsState(state) {
    let addToBundleButtons = document.querySelectorAll('.js-add-to-bundle');
    let addToCartButtons = document.querySelectorAll('.js-add-bundle-to-cart');

    if(state === 'ready') {
        addToBundleButtons.forEach(btn => {
            btn.disabled = true;
            btn.textContent = 'Bundle Full';
        });
        addToCartButtons.forEach(btn => {
            btn.disabled = false;
        });
    } else {
        addToBundleButtons.forEach(btn => {
            btn.disabled = false;
            btn.textContent = 'Add to Bundle';
        });
        addToCartButtons.forEach(btn => {
            btn.disabled = true;
        });
    }
}

function removeFromBundle(variantId) {
    let bundleProducts = document.querySelectorAll('.js-bundle-product');
    let bundleBuilder = document.querySelector('.js-bundle-builder');
    let bundleBuilderProducts = bundleBuilder.querySelectorAll('.js-bundle-product');
    bundleProducts.forEach((product, index) => {
        if(product.dataset.variantId === variantId) {
            product.classList.add('empty');
            product.dataset.productId = '';
            product.dataset.price = '0';
            product.dataset.variantId = '';
            product.querySelector('.js-bundle-product-image').src = productImageDefault;
            product.querySelector('.js-bundle-product-image').srcset = productImageDefault;
            product.querySelector('.js-bundle-product-title').innerHTML = '';
            product.querySelector('.js-bundle-product-remove').dataset.variantId = '';
        }
    });

    updateBundlePrice(bundleBuilderProducts);
    updateButtonsState('not-ready');
}

function addBundleToCart() {
    let bundleBuilder = document.querySelector('.js-bundle-builder');
    let bundleBuilderProducts = bundleBuilder.querySelectorAll('.js-bundle-product:not(.empty)');
    
    let formData = {
        'items': []
    };
    bundleBuilderProducts.forEach(product => {
        formData.items.push({
            'id': product.dataset.variantId,
            'quantity': 1,
            'properties': {
                '_custom_bundle': 'true'
            }
        });
    });

       
    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
    .then(response => {
        return response.json();
    })
    .catch((error) => {
        console.error('Error:', error);
    });

   bundleBuilderProducts.forEach(product => {
        removeFromBundle(product.dataset.variantId);
    })
}

function updateSelectedProductVariant(optionValue, skipFiltering) {
    let optionName = optionValue.dataset.optionItem;
    let productId = optionValue.dataset.productId;

    let optionInner = optionValue.closest('.product-block-options');
    let optionValues = optionInner.querySelectorAll('.js-bundle-product-card-option-value');
    optionValues.forEach(optionValue => {
        optionValue.classList.remove('selected');
    });
    optionValue.classList.add('selected');
    
    let productCard = document.querySelector(`.js-custom-bundle-product-grid-item[data-product-id="${productId}"]`);
    let variantInputs = productCard.querySelectorAll('.js-bundle-product-variant');
    let selectedOptions = productCard.querySelectorAll('.js-bundle-product-card-option-value.selected');

    let selectedValues = [];
    selectedOptions.forEach(option => {
        selectedValues.push(option.dataset.optionItem);
    });


    let imageUrl = '';
    let available = false;
    let price = 0;
    let imageAltText = '';
    let variantMatch = false;

    variantInputs.forEach(variantInput => {
        if(selectedValues.every(value => variantInput.dataset.title.includes(value))) {
            variantInput.classList.add('selected');
            imageUrl = variantInput.dataset.image;
            imageAltText = variantInput.dataset.imageAltText;
            available = variantInput.dataset.available;
            price = variantInput.dataset.price;
            variantMatch = true;
        } else {
            variantInput.classList.remove('selected');
        }
    });

    if(!variantMatch) {
        filterAvailableOptions(productCard, variantInputs, selectedValues);
    } else {

        let productImageEl = productCard.querySelector('.js-bundle-product-card-image');
        productImageEl.src = imageUrl;
        productImageEl.srcset = imageUrl;
        productImageEl.alt = imageAltText;
        productCard.querySelector('.js-bundle-product-card-price').innerHTML = '$' + price;

        let optionNameEL = optionValue.closest('.custom-bundle-product-grid-item-variant-picker-option').querySelector('.js-option-value');
        optionNameEL.innerHTML = optionName;

        let addToBundleButton = productCard.querySelector('.js-add-to-bundle');
        if(available === 'true') {
            addToBundleButton.disabled = false;
            addToBundleButton.textContent = 'Add to Bundle';
        } else {
            addToBundleButton.disabled = true;
            addToBundleButton.textContent = 'Sold Out';
        }
    }
    
    // Always filter available options for subsequent option groups based on current selection
    if (!skipFiltering) {
        filterAvailableOptions(productCard, variantInputs, selectedValues);
    }
    
}

function filterAvailableOptions(productCard, variantInputs, selectedValues) {
    let optionGroups = productCard.querySelectorAll('.js-bundle-product-card-option');
    
    optionGroups.forEach((optionGroup, groupIndex) => {
        if (groupIndex === 0) return;
        
        let optionValues = optionGroup.querySelectorAll('.js-bundle-product-card-option-value');
        let availableOptions = [];
        let currentlySelected = optionGroup.querySelector('.js-bundle-product-card-option-value.selected');
        
        optionValues.forEach(optionValue => {
            let testSelectedValues = [...selectedValues];
            
            while (testSelectedValues.length <= groupIndex) {
                testSelectedValues.push(optionValue.dataset.optionItem);
            }
            testSelectedValues[groupIndex] = optionValue.dataset.optionItem;
            
            let isAvailable = false;
            variantInputs.forEach(variantInput => {
                if (testSelectedValues.every(value => variantInput.dataset.title.includes(value))) {
                    isAvailable = true;
                }
            });
            
            if (isAvailable) {
                optionValue.style.display = '';
                optionValue.classList.remove('unavailable');
                availableOptions.push(optionValue);
            } else {
                optionValue.style.display = 'none';
                optionValue.classList.add('unavailable');
            }
        });
        
        let currentSelectionStillValid = false;
        if (currentlySelected && availableOptions.includes(currentlySelected)) {
            currentSelectionStillValid = true;
        }
        
        if (!currentSelectionStillValid && availableOptions.length > 0) {
            optionValues.forEach(option => option.classList.remove('selected'));
            
            let firstAvailable = availableOptions[0];
            firstAvailable.classList.add('selected');
            
            let optionNameEL = optionGroup.querySelector('.js-option-value');
            if (optionNameEL) {
                optionNameEL.innerHTML = firstAvailable.dataset.optionItem;
            }
            
            updateSelectedProductVariant(firstAvailable, true);
        }
    });
}

function changeDealOption(dealOption) {
    const customBundleContainer = document.querySelector('.js-custom-bundle-container');
    customBundleContainer.dataset.dealOption = dealOption;
    const bundleBuilderModal = document.querySelector('.js-bundle-builder-modal');
    bundleBuilderModal.dataset.dealOption = dealOption;
    const bundleBuilderProducts4thItem = bundleBuilderModal.querySelectorAll('.js-bundle-product')[3];
    const lastItemVariantID = bundleBuilderProducts4thItem.dataset.variantId;

    if(lastItemVariantID) {
        removeFromBundle(lastItemVariantID);
    }

    if(dealOption === '2') {
        bundleBuilderProducts4thItem.classList.add('active');
    } else {
        bundleBuilderProducts4thItem.classList.remove('active');
    }

    let activeBundleItems = customBundleContainer.querySelectorAll('.js-bundle-product:not(.empty)').length;
    console.log('activeBundleItems', activeBundleItems);
    console.log('dealOption', dealOption);
    if(dealOption === '1' && activeBundleItems === 3 || dealOption === '2' && activeBundleItems === 4) {
        updateButtonsState('ready');
    } else {
        updateButtonsState('not-ready');
    }
}

window.addEventListener('load', () => {
    initCustomBundle();
});